// extracted by mini-css-extract-plugin
export default {"inlineSpinner":"sXTEJ3UsmcAY6QLvNMcj","inline-spin":"AbzQGHAiD87BgkeHD6ae","primary":"_o07RBWQdmnx7U8mSrtR","muted":"enTrUZgpMHdZZy0Fkpnt","inverse":"DQu7tGK7ONaEAUMd46tU"};